function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/* eslint no-unused-vars: "off" */

/**
 * Model for a Chart
 * All of these methods should return very quickly.
 * If data needs to be loaded asynchronously, return something immediately, then trigger an event for the chart to refresh.
 */
class ChartModel {
  constructor(dh) {
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "listeners", void 0);
    /** Formatter settings for the chart, such as how to format dates and numbers */
    _defineProperty(this, "formatter", void 0);
    _defineProperty(this, "renderOptions", void 0);
    _defineProperty(this, "rect", void 0);
    _defineProperty(this, "isDownsamplingDisabled", void 0);
    _defineProperty(this, "title", void 0);
    this.dh = dh;
    this.listeners = [];
    this.isDownsamplingDisabled = false;
  }
  getData() {
    return [];
  }
  getDefaultTitle() {
    return '';
  }
  getLayout() {
    return {};
  }
  getFilterColumnMap() {
    return new Map();
  }

  /**
   * Whether this model has selection callbacks (on_selected/on_deselect) registered.
   * When true, the chart should show box/lasso select mode bar buttons.
   * @returns True if selection callbacks are registered
   */
  hasSelectionCallbacks() {
    return false;
  }
  isFilterRequired() {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setFilter(filter) {}

  /**
   * Close this model, clean up any underlying subscriptions
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  close() {}

  /**
   * Set the formatter to use when charting the data.
   * @param formatter The formatter to use to format the charting data
   */
  setFormatter(formatter) {
    this.formatter = formatter;
  }

  /**
   * Set additional options for rendering the chart
   * @param renderOptions Options for rendering the chart
   */
  setRenderOptions(renderOptions) {
    this.renderOptions = renderOptions;
  }

  /**
   * Disable downsampling
   * @param isDownsamplingDisabled True if downsampling should be disabled
   */
  setDownsamplingDisabled(isDownsamplingDisabled) {
    this.isDownsamplingDisabled = isDownsamplingDisabled;
  }

  /**
   * Set the dimensions of the plot. May be needed to evaluate some of the percents
   * @param rect The bounding rectangle of the plot
   */
  setDimensions(rect) {
    this.rect = rect;
  }
  setTitle(title) {
    this.title = title;
  }

  /**
   * Subscribe to this ChartModel and start listening for all events.
   * @param callback Callback when an event occurs
   */
  subscribe(callback) {
    this.listeners.push(callback);
  }
  unsubscribe(callback) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  }
  fireEvent(event) {
    for (var i = 0; i < this.listeners.length; i += 1) {
      this.listeners[i](event);
    }
  }
  fireUpdate(data) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_UPDATED, {
      detail: data
    }));
  }
  fireDisconnect() {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_DISCONNECT));
  }
  fireReconnect() {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_RECONNECT));
  }
  fireDownsampleStart(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_DOWNSAMPLESTARTED, {
      detail
    }));
  }
  fireDownsampleFinish(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_DOWNSAMPLEFINISHED, {
      detail
    }));
  }
  fireDownsampleFail(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_DOWNSAMPLEFAILED, {
      detail
    }));
  }
  fireDownsampleNeeded(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_DOWNSAMPLENEEDED, {
      detail
    }));
  }
  fireLoadFinished() {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_LOADFINISHED));
  }
  fireError(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_ERROR, {
      detail
    }));
  }
  fireBlocker(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_BLOCKER, {
      detail
    }));
  }
  fireBlockerClear() {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_BLOCKER_CLEAR));
  }
  fireLayoutUpdated(detail) {
    this.fireEvent(new CustomEvent(ChartModel.EVENT_LAYOUT_UPDATED, {
      detail
    }));
  }
}
_defineProperty(ChartModel, "EVENT_UPDATED", 'ChartModel.EVENT_UPDATED');
_defineProperty(ChartModel, "EVENT_DISCONNECT", 'ChartModel.EVENT_DISCONNECT');
_defineProperty(ChartModel, "EVENT_RECONNECT", 'ChartModel.EVENT_RECONNECT');
_defineProperty(ChartModel, "EVENT_DOWNSAMPLESTARTED", 'ChartModel.EVENT_DOWNSAMPLESTARTED');
_defineProperty(ChartModel, "EVENT_DOWNSAMPLEFINISHED", 'ChartModel.EVENT_DOWNSAMPLEFINISHED');
_defineProperty(ChartModel, "EVENT_DOWNSAMPLEFAILED", 'ChartModel.EVENT_DOWNSAMPLEFAILED');
_defineProperty(ChartModel, "EVENT_DOWNSAMPLENEEDED", 'ChartModel.EVENT_DOWNSAMPLENEEDED');
_defineProperty(ChartModel, "EVENT_LOADFINISHED", 'ChartModel.EVENT_LOADFINISHED');
_defineProperty(ChartModel, "EVENT_ERROR", 'ChartModel.EVENT_ERROR');
_defineProperty(ChartModel, "EVENT_BLOCKER", 'ChartModel.EVENT_BLOCKER');
_defineProperty(ChartModel, "EVENT_BLOCKER_CLEAR", 'ChartModel.EVENT_BLOCKER_CLEAR');
_defineProperty(ChartModel, "EVENT_LAYOUT_UPDATED", 'ChartModel.EVENT_LAYOUT_UPDATED');
export default ChartModel;
//# sourceMappingURL=ChartModel.js.map